export const MORADO_COLOR = '#6a2c90';
export const CYAN_COLOR = '#4EA2A2';
export const AZUL_COLOR = '#211D5A';
export const NEGRO_COLOR = '#000000';
export const BLANCO_COLOR = '#FFFFFF';
export const DANGER_COLOR = '#c70000';
